var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box pb-5"},[_c('h3',{staticClass:"text-white p-3"},[_vm._v("金额统计数据132456")]),_c('div',{attrs:{"id":"line_chart"}})])
}]

export { render, staticRenderFns }